import { useEffect } from 'react';
import { getSortField, getSortValue, sortKey } from '../../../../../features/table/helpers';
import { defaultViewStyle, viewStyleKey, withArchiveKey } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { SortType } from '../../../../../types/props';

export const useBranches = () => {
  const { fetchBranches, place, restoreBranch } = useBranchesStore();
  const { t } = useLang();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const name = params['name'];
  const description = params['description'];
  const zip = params['zip'];
  const address = params['address'];
  const phone = params['phone'];
  const createdAt = params['created_at'];
  const staff_count = params['staff_count'];
  const with_archive = params[withArchiveKey];
  const sort = params[sortKey];
  const sortField = getSortField(sort);
  const sortDirection = getSortValue(sort) as SortType;
  const viewStyle = params[viewStyleKey] || defaultViewStyle;

  useEffect(() => {
    fetchBranches({
      n: 1000,
      since_id: 0,
      with_archive: !!with_archive,

      name,
      description,
      zip,
      address,
      phone,
      created_at: createdAt,
      staff_count,

      field: sortField,
      dir: sortDirection,
    });
  }, [
    address,
    createdAt,
    description,
    staff_count,
    name,
    phone,
    sortDirection,
    sortField,
    zip,
    with_archive,
  ]);

  const createBranchModal = useModalParams('createBranch');

  const archiveBranchModal = useModalParams('archiveBranch');

  const editBranchModal = useModalParams('editBranch');

  return {
    place,
    archiveBranchModal,
    createBranchModal,
    editBranchModal,
    t,
    restoreBranch,
    viewStyle,
  };
};
